import { render, staticRenderFns } from "./TechChipsContainer.vue?vue&type=template&id=6571e136&"
import script from "./TechChipsContainer.vue?vue&type=script&lang=js&"
export * from "./TechChipsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports